import ProductCardWithBundle from '@src/quince-site-common/src/domains/ProductCardWithBundle'

import { IProductFeedResponseForCollection } from './CollectionService.types'

export const getProductIdCounts = (productCards: ProductCardWithBundle[]) =>
  productCards.reduce((map: Record<number, number>, productCard) => {
    const count = map[productCard.product.shopifyProductId as number] ?? 0
    map[productCard.product.shopifyProductId as number] = count + 1
    return map
  }, {})

export const getProductCardsFromCollection = (collection: IProductFeedResponseForCollection) => {
  return collection.subCollections
    .map(subCollection => {
      if (subCollection.productCards) return subCollection.productCards

      return []
    })
    .flat()
}
